import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  Input,
} from '@angular/core';
// import Swiper from 'swiper';

@Component({
  selector: 'app-swiper-carousel',
  templateUrl: './swiper-carousel.component.html',
  styleUrls: ['./swiper-carousel.component.scss'],
  standalone: false,
})
export class SwiperCarouselComponent implements AfterViewInit {
  @ViewChild('swiperEl', { static: false }) swiperEl!: ElementRef | undefined;
  @Input() carouselImgs: any = [];

  constructor() {}

  ngAfterViewInit() {
    if (this.swiperEl) {
      this.initSwiper();
    } else {
      console.error('Swiper element not found!');
    }
  }

  initSwiper() {
    // const swiper = new Swiper(this.swiperEl?.nativeElement, {
    //   slidesPerView: 1,
    //   spaceBetween: 10,
    //   autoplay: {
    //     delay: 1500,
    //     disableOnInteraction: false,
    //   },
    // });
    // swiper.autoplay.start();
  }
}
